/** VERSION: 1.0.0 Please do not delete this line. Thank you! **/
if(typeof lazySizes !== 'function' && typeof lazySizes !== 'object' || typeof lazySizes === 'undefined'){
  /*! lazysizes - v4.1.8 */
  !function (a, b) { var c = b(a, a.document); a.lazySizes = c, "object" == typeof module && module.exports && (module.exports = c) }(window, function (a, b) { "use strict"; if (b.getElementsByClassName) { var c, d, e = b.documentElement, f = a.Date, g = a.HTMLPictureElement, h = "addEventListener", i = "getAttribute", j = a[h], k = a.setTimeout, l = a.requestAnimationFrame || k, m = a.requestIdleCallback, n = /^picture$/i, o = ["load", "error", "lazyincluded", "_lazyloaded"], p = {}, q = Array.prototype.forEach, r = function (a, b) { return p[b] || (p[b] = new RegExp("(\\s|^)" + b + "(\\s|$)")), p[b].test(a[i]("class") || "") && p[b] }, s = function (a, b) { r(a, b) || a.setAttribute("class", (a[i]("class") || "").trim() + " " + b) }, t = function (a, b) { var c; (c = r(a, b)) && a.setAttribute("class", (a[i]("class") || "").replace(c, " ")) }, u = function (a, b, c) { var d = c ? h : "removeEventListener"; c && u(a, b), o.forEach(function (c) { a[d](c, b) }) }, v = function (a, d, e, f, g) { var h = b.createEvent("Event"); return e || (e = {}), e.instance = c, h.initEvent(d, !f, !g), h.detail = e, a.dispatchEvent(h), h }, w = function (b, c) { var e; !g && (e = a.picturefill || d.pf) ? (c && c.src && !b[i]("srcset") && b.setAttribute("srcset", c.src), e({ reevaluate: !0, elements: [b] })) : c && c.src && (b.src = c.src) }, x = function (a, b) { return (getComputedStyle(a, null) || {})[b] }, y = function (a, b, c) { for (c = c || a.offsetWidth; c < d.minSize && b && !a._lazysizesWidth;)c = b.offsetWidth, b = b.parentNode; return c }, z = function () { var a, c, d = [], e = [], f = d, g = function () { var b = f; for (f = d.length ? e : d, a = !0, c = !1; b.length;)b.shift()(); a = !1 }, h = function (d, e) { a && !e ? d.apply(this, arguments) : (f.push(d), c || (c = !0, (b.hidden ? k : l)(g))) }; return h._lsFlush = g, h }(), A = function (a, b) { return b ? function () { z(a) } : function () { var b = this, c = arguments; z(function () { a.apply(b, c) }) } }, B = function (a) { var b, c = 0, e = d.throttleDelay, g = d.ricTimeout, h = function () { b = !1, c = f.now(), a() }, i = m && g > 49 ? function () { m(h, { timeout: g }), g !== d.ricTimeout && (g = d.ricTimeout) } : A(function () { k(h) }, !0); return function (a) { var d; (a = !0 === a) && (g = 33), b || (b = !0, d = e - (f.now() - c), d < 0 && (d = 0), a || d < 9 ? i() : k(i, d)) } }, C = function (a) { var b, c, d = 99, e = function () { b = null, a() }, g = function () { var a = f.now() - c; a < d ? k(g, d - a) : (m || e)(e) }; return function () { c = f.now(), b || (b = k(g, d)) } }; !function () { var b, c = { lazyClass: "lazyload", loadedClass: "lazyloaded", loadingClass: "lazyloading", preloadClass: "lazypreload", errorClass: "lazyerror", autosizesClass: "lazyautosizes", srcAttr: "data-src", srcsetAttr: "data-srcset", sizesAttr: "data-sizes", minSize: 40, customMedia: {}, init: !0, expFactor: 1.5, hFac: .8, loadMode: 2, loadHidden: !0, ricTimeout: 0, throttleDelay: 125 }; d = a.lazySizesConfig || a.lazysizesConfig || {}; for (b in c) b in d || (d[b] = c[b]); a.lazySizesConfig = d, k(function () { d.init && F() }) }(); var D = function () { var g, l, m, o, p, y, D, F, G, H, I, J, K = /^img$/i, L = /^iframe$/i, M = "onscroll" in a && !/(gle|ing)bot/.test(navigator.userAgent), N = 0, O = 0, P = 0, Q = -1, R = function (a) { P-- , (!a || P < 0 || !a.target) && (P = 0) }, S = function (a) { return null == J && (J = "hidden" == x(b.body, "visibility")), J || "hidden" != x(a.parentNode, "visibility") && "hidden" != x(a, "visibility") }, T = function (a, c) { var d, f = a, g = S(a); for (F -= c, I += c, G -= c, H += c; g && (f = f.offsetParent) && f != b.body && f != e;)(g = (x(f, "opacity") || 1) > 0) && "visible" != x(f, "overflow") && (d = f.getBoundingClientRect(), g = H > d.left && G < d.right && I > d.top - 1 && F < d.bottom + 1); return g }, U = function () { var a, f, h, j, k, m, n, p, q, r, s, t, u = c.elements; if ((o = d.loadMode) && P < 8 && (a = u.length)) { for (f = 0, Q++; f < a; f++)if (u[f] && !u[f]._lazyRace) if (!M || c.prematureUnveil && c.prematureUnveil(u[f])) aa(u[f]); else if ((p = u[f][i]("data-expand")) && (m = 1 * p) || (m = O), r || (r = !d.expand || d.expand < 1 ? e.clientHeight > 500 && e.clientWidth > 500 ? 500 : 370 : d.expand, c._defEx = r, s = r * d.expFactor, t = d.hFac, J = null, O < s && P < 1 && Q > 2 && o > 2 && !b.hidden ? (O = s, Q = 0) : O = o > 1 && Q > 1 && P < 6 ? r : N), q !== m && (y = innerWidth + m * t, D = innerHeight + m, n = -1 * m, q = m), h = u[f].getBoundingClientRect(), (I = h.bottom) >= n && (F = h.top) <= D && (H = h.right) >= n * t && (G = h.left) <= y && (I || H || G || F) && (d.loadHidden || S(u[f])) && (l && P < 3 && !p && (o < 3 || Q < 4) || T(u[f], m))) { if (aa(u[f]), k = !0, P > 9) break } else !k && l && !j && P < 4 && Q < 4 && o > 2 && (g[0] || d.preloadAfterLoad) && (g[0] || !p && (I || H || G || F || "auto" != u[f][i](d.sizesAttr))) && (j = g[0] || u[f]); j && !k && aa(j) } }, V = B(U), W = function (a) { var b = a.target; if (b._lazyCache) return void delete b._lazyCache; R(a), s(b, d.loadedClass), t(b, d.loadingClass), u(b, Y), v(b, "lazyloaded") }, X = A(W), Y = function (a) { X({ target: a.target }) }, Z = function (a, b) { try { a.contentWindow.location.replace(b) } catch (c) { a.src = b } }, $ = function (a) { var b, c = a[i](d.srcsetAttr); (b = d.customMedia[a[i]("data-media") || a[i]("media")]) && a.setAttribute("media", b), c && a.setAttribute("srcset", c) }, _ = A(function (a, b, c, e, f) { var g, h, j, l, o, p; (o = v(a, "lazybeforeunveil", b)).defaultPrevented || (e && (c ? s(a, d.autosizesClass) : a.setAttribute("sizes", e)), h = a[i](d.srcsetAttr), g = a[i](d.srcAttr), f && (j = a.parentNode, l = j && n.test(j.nodeName || "")), p = b.firesLoad || "src" in a && (h || g || l), o = { target: a }, s(a, d.loadingClass), p && (clearTimeout(m), m = k(R, 2500), u(a, Y, !0)), l && q.call(j.getElementsByTagName("source"), $), h ? a.setAttribute("srcset", h) : g && !l && (L.test(a.nodeName) ? Z(a, g) : a.src = g), f && (h || l) && w(a, { src: g })), a._lazyRace && delete a._lazyRace, t(a, d.lazyClass), z(function () { var b = a.complete && a.naturalWidth > 1; p && !b || (b && s(a, "ls-is-cached"), W(o), a._lazyCache = !0, k(function () { "_lazyCache" in a && delete a._lazyCache }, 9)), "lazy" == a.loading && P-- }, !0) }), aa = function (a) { if (!a._lazyRace) { var b, c = K.test(a.nodeName), e = c && (a[i](d.sizesAttr) || a[i]("sizes")), f = "auto" == e; (!f && l || !c || !a[i]("src") && !a.srcset || a.complete || r(a, d.errorClass) || !r(a, d.lazyClass)) && (b = v(a, "lazyunveilread").detail, f && E.updateElem(a, !0, a.offsetWidth), a._lazyRace = !0, P++ , _(a, b, f, e, c)) } }, ba = C(function () { d.loadMode = 3, V() }), ca = function () { 3 == d.loadMode && (d.loadMode = 2), ba() }, da = function () { if (!l) { if (f.now() - p < 999) return void k(da, 999); l = !0, d.loadMode = 3, V(), j("scroll", ca, !0) } }; return { _: function () { p = f.now(), c.elements = b.getElementsByClassName(d.lazyClass), g = b.getElementsByClassName(d.lazyClass + " " + d.preloadClass), j("scroll", V, !0), j("resize", V, !0), a.MutationObserver ? new MutationObserver(V).observe(e, { childList: !0, subtree: !0, attributes: !0 }) : (e[h]("DOMNodeInserted", V, !0), e[h]("DOMAttrModified", V, !0), setInterval(V, 999)), j("hashchange", V, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend", "webkitAnimationEnd"].forEach(function (a) { b[h](a, V, !0) }), /d$|^c/.test(b.readyState) ? da() : (j("load", da), b[h]("DOMContentLoaded", V), k(da, 2e4)), c.elements.length ? (U(), z._lsFlush()) : V() }, checkElems: V, unveil: aa, _aLSL: ca } }(), E = function () { var a, c = A(function (a, b, c, d) { var e, f, g; if (a._lazysizesWidth = d, d += "px", a.setAttribute("sizes", d), n.test(b.nodeName || "")) for (e = b.getElementsByTagName("source"), f = 0, g = e.length; f < g; f++)e[f].setAttribute("sizes", d); c.detail.dataAttr || w(a, c.detail) }), e = function (a, b, d) { var e, f = a.parentNode; f && (d = y(a, f, d), e = v(a, "lazybeforesizes", { width: d, dataAttr: !!b }), e.defaultPrevented || (d = e.detail.width) && d !== a._lazysizesWidth && c(a, f, e, d)) }, f = function () { var b, c = a.length; if (c) for (b = 0; b < c; b++)e(a[b]) }, g = C(f); return { _: function () { a = b.getElementsByClassName(d.autosizesClass), j("resize", g) }, checkElems: g, updateElem: e } }(), F = function () { F.i || (F.i = !0, E._(), D._()) }; return c = { cfg: d, autoSizer: E, loader: D, init: F, uP: w, aC: s, rC: t, hC: r, fire: v, gW: y, rAF: z } } });
  /*! ls.rias.min.ks - v4.1.8 */
  !function (a, b) { var c = function () { b(a.lazySizes), a.removeEventListener("lazyunveilread", c, !0) }; b = b.bind(null, a, a.document), "object" == typeof module && module.exports ? b(require("lazysizes")) : a.lazySizes ? c() : a.addEventListener("lazyunveilread", c, !0) }(window, function (a, b, c) { "use strict"; function d(b, c) { var d, e, f, g, h = a.getComputedStyle(b); e = b.parentNode, g = { isPicture: !(!e || !m.test(e.nodeName || "")) }, f = function (a, c) { var d = b.getAttribute("data-" + a); if (!d) { var e = h.getPropertyValue("--ls-" + a); e && (d = e.trim()) } if (d) { if ("true" == d) d = !0; else if ("false" == d) d = !1; else if (l.test(d)) d = parseFloat(d); else if ("function" == typeof j[a]) d = j[a](b, d); else if (q.test(d)) try { d = JSON.parse(d) } catch (a) { } g[a] = d } else a in j && "function" != typeof j[a] ? g[a] = j[a] : c && "function" == typeof j[a] && (g[a] = j[a](b, d)) }; for (d in j) f(d); return c.replace(p, function (a, b) { b in g || f(b, !0) }), g } function e(a, b) { var c = [], d = function (a, c) { return k[typeof b[c]] ? b[c] : a }; return c.srcset = [], b.absUrl && (s.setAttribute("href", a), a = s.href), a = ((b.prefix || "") + a + (b.postfix || "")).replace(p, d), b.widths.forEach(function (d) { var e = b.widthmap[d] || d, f = b.aspectratio || b.ratio, g = !b.aspectratio && j.traditionalRatio, h = { u: a.replace(n, e).replace(o, f ? g ? Math.round(d * f) : Math.round(d / f) : ""), w: d }; c.push(h), c.srcset.push(h.c = h.u + " " + d + "w") }), c } function f(a, c, d) { var f = 0, g = 0, h = d; if (a) { if ("container" === c.ratio) { for (f = h.scrollWidth, g = h.scrollHeight; !(f && g || h === b);)h = h.parentNode, f = h.scrollWidth, g = h.scrollHeight; f && g && (c.ratio = g / f) } a = e(a, c), a.isPicture = c.isPicture, u && "IMG" == d.nodeName.toUpperCase() ? d.removeAttribute(i.srcsetAttr) : d.setAttribute(i.srcsetAttr, a.srcset.join(", ")), Object.defineProperty(d, "_lazyrias", { value: a, writable: !0 }) } } function g(a, b) { var e = d(a, b); return j.modifyOptions.call(a, { target: a, details: e, detail: e }), c.fire(a, "lazyriasmodifyoptions", e), e } function h(a) { return a.getAttribute(a.getAttribute("data-srcattr") || j.srcAttr) || a.getAttribute(i.srcsetAttr) || a.getAttribute(i.srcAttr) || a.getAttribute("data-pfsrcset") || "" } var i, j, k = { string: 1, number: 1 }, l = /^\-*\+*\d+\.*\d*$/, m = /^picture$/i, n = /\s*\{\s*width\s*\}\s*/i, o = /\s*\{\s*height\s*\}\s*/i, p = /\s*\{\s*([a-z0-9]+)\s*\}\s*/gi, q = /^\[.*\]|\{.*\}$/, r = /^(?:auto|\d+(px)?)$/, s = b.createElement("a"), t = b.createElement("img"), u = "srcset" in t && !("sizes" in t), v = !!a.HTMLPictureElement && !u; !function () { var b, d = function () { }, e = { prefix: "", postfix: "", srcAttr: "data-src", absUrl: !1, modifyOptions: d, widthmap: {}, ratio: !1, traditionalRatio: !1, aspectratio: !1 }; i = c && c.cfg || a.lazySizesConfig, i || (i = {}, a.lazySizesConfig = i), i.supportsType || (i.supportsType = function (a) { return !a }), i.rias || (i.rias = {}), "widths" in (j = i.rias) || (j.widths = [], function (a) { for (var b, c = 0; !b || b < 3e3;)c += 5, c > 30 && (c += 1), b = 36 * c, a.push(b) }(j.widths)); for (b in e) b in j || (j[b] = e[b]) }(), addEventListener("lazybeforesizes", function (a) { if (a.detail.instance == c) { var b, d, e, k, l, m, o, p, q, s, t, u, x; if (b = a.target, a.detail.dataAttr && !a.defaultPrevented && !j.disabled && (q = b.getAttribute(i.sizesAttr) || b.getAttribute("sizes")) && r.test(q)) { if (d = h(b), e = g(b, d), t = n.test(e.prefix) || n.test(e.postfix), e.isPicture && (k = b.parentNode)) for (l = k.getElementsByTagName("source"), m = 0, o = l.length; m < o; m++)(t || n.test(p = h(l[m]))) && (f(p, e, l[m]), u = !0); t || n.test(d) ? (f(d, e, b), u = !0) : u && (x = [], x.srcset = [], x.isPicture = !0, Object.defineProperty(b, "_lazyrias", { value: x, writable: !0 })), u && (v ? b.removeAttribute(i.srcAttr) : "auto" != q && (s = { width: parseInt(q, 10) }, w({ target: b, detail: s }))) } } }, !0); var w = function () { var d = function (a, b) { return a.w - b.w }, e = function (a) { var b, c, d = a.length, e = a[d - 1], f = 0; for (f; f < d; f++)if (e = a[f], e.d = e.w / a.w, e.d >= a.d) { !e.cached && (b = a[f - 1]) && b.d > a.d - .13 * Math.pow(a.d, 2.2) && (c = Math.pow(b.d - .6, 1.6), b.cached && (b.d += .15 * c), b.d + (e.d - a.d) * c > a.d && (e = b)); break } return e }, f = function (a, b) { var d; return !a._lazyrias && c.pWS && (d = c.pWS(a.getAttribute(i.srcsetAttr || ""))).length && (Object.defineProperty(a, "_lazyrias", { value: d, writable: !0 }), b && a.parentNode && (d.isPicture = "PICTURE" == a.parentNode.nodeName.toUpperCase())), a._lazyrias }, g = function (b) { var d = a.devicePixelRatio || 1, e = c.getX && c.getX(b); return Math.min(e || d, 2.4, d) }, h = function (b, c) { var h, i, j, k, l, m; if (l = b._lazyrias, l.isPicture && a.matchMedia) for (i = 0, h = b.parentNode.getElementsByTagName("source"), j = h.length; i < j; i++)if (f(h[i]) && !h[i].getAttribute("type") && (!(k = h[i].getAttribute("media")) || (matchMedia(k) || {}).matches)) { l = h[i]._lazyrias; break } return (!l.w || l.w < c) && (l.w = c, l.d = g(b), m = e(l.sort(d))), m }, j = function (d) { if (d.detail.instance == c) { var e, g = d.target; if (!u && (a.respimage || a.picturefill || lazySizesConfig.pf)) return void b.removeEventListener("lazybeforesizes", j); ("_lazyrias" in g || d.detail.dataAttr && f(g, !0)) && (e = h(g, d.detail.width)) && e.u && g._lazyrias.cur != e.u && (g._lazyrias.cur = e.u, e.cached = !0, c.rAF(function () { g.setAttribute(i.srcAttr, e.u), g.setAttribute("src", e.u) })) } }; return v ? j = function () { } : addEventListener("lazybeforesizes", j), j }() });
}

// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
general: {
  filterTreeMobileStyle: 'style3',
  breakpointMobile: 989,
  limit: boostPFSThemeConfig.custom.products_per_page,
  showLimitList: '6,12,24,36,48',
  /* Optional */
  loadProductFirst: false,
  paginationType: 'load_more',
  keepScrollbackPositionType: 'history',
  // Placeholder
  showPlaceholderProductList: true,
  placeholderProductPerRow: 4,
  enableOTP: true,
  aspect_ratio: boostPFSThemeConfig.custom.aspect_ratio,
  cropImagePossitionEqualHeight: boostPFSThemeConfig.custom.product_img_crop,
  defaultDisplay: boostPFSThemeConfig.custom.product_item_type,
  forceCapitalizeFilterOptionValues: true,
  selectOptionContainer: '.boost-pfs-filter-product-item-image',  // CSS selector to append the product option, if left empty it will append to the product item
},
selector: {
  otpButtons: '.boost-pfs-filter-product-item-image',
}
};

(function() {
var onSale = false,
  soldOut = false,
  priceVaries = false,
  shopInStoreProduct = false,
  priceOnRequestProduct = false,
  showSticker = false,
  isAvailable,
  vatExists,
  vatExempt,
  vatRate,
  discountTag,
  discountValue,
  images = [],
  firstVariant = {},
  boostPFSImgDefaultSrc = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  boostPFSRangeWidths = [180, 360, 540];

BoostPFS.inject(this);
boostPFSFilterConfig.general.separateRefineByFromFilter = (jQ('.boost-pfs-filter-tree-h').length && !Utils.isMobile() > 0 && boostPFSThemeConfig.custom.filter_tree_horizontal_style != 'style-expand') ? true : false;
Selector.stickyElementDesktop = jQ('.boost-pfs-filter-left-col').length > 0 && !Utils.isMobile() ? '.boost-pfs-filter-left-col' : '.boost-pfs-filter-tree';
/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
function prepareShopifyData(data) {
  // Displaying price base on the policy of Shopify, have to multiple by 100
  isAvailable = data.available; // Check a product is available
  soldOut = !data.available; // Check a product is out of stock
  onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
  priceVaries = data.price_min != data.price_max; // Check a product has many prices
  stickerTags = data.tags.filter(tag => tag.includes('sticker:'));
  if (stickerTags.length > 0) {
    showSticker = true;
  }
  if (boostPFSThemeConfig.custom.shop_in_store_tag.length > 0) {
    let shop_in_store_tags = data.tags.filter(tag => tag == boostPFSThemeConfig.custom.shop_in_store_tag);
    if (shop_in_store_tags.length > 0){
        shopInStoreProduct = true;
    } else {
        shopInStoreProduct = false;
    }
  }

  let shop_in_store_metafields = data.metafields.filter(metafield => metafield.key == "in_store_only" && metafield.value == "true");
  if (shop_in_store_metafields.length > 0){
    shopInStoreProduct = true;
  }

  priceOnRequestProduct = false;

  let price_on_request_metafields = data.metafields.filter(metafield => metafield.key == "price_on_request" && metafield.value == "true");


  if (price_on_request_metafields.length > 0){
    priceOnRequestProduct = true;
  }

  // Convert images to array
  images = data.images_info;
  // Get First Variant (selected_or_first_available_variant)
  firstVariant = data['variants'][0];
  if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
    var paramVariant = data.variants.filter(function(e) {
      return e.id == Utils.getParam('variant');
    });
    if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
  } else {
    for (var i = 0; i < data['variants'].length; i++) {
      if (data['variants'][i].available) {
        firstVariant = data['variants'][i];
        break;
      }
    }
  }
	vatExists = false;
	vatExempt = false;
	vatRate = 1;
	discountTag = false;

  return data;
}

/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
/************************** BUILD PRODUCT ITEM **************************/
// Build Product Grid Item
ProductGridItem.prototype.compileTemplate = function(data) {
  if (!data) data = this.data;
  // Customize API data to get the Shopify data
  data = prepareShopifyData(data);

  // Get Template
  var itemHtml = boostPFSTemplate.productGridItemHtml;

  // Add Images
  itemHtml = itemHtml.replace(/{{itemImages}}/g, buildImages(data));

  // Add Price
  if (priceOnRequestProduct || soldOut) {
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, "");
  } else {
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, buildPrice(data));
  }


  // Add Review
  if (typeof Integration === 'undefined' ||
    (typeof Integration != 'undefined' &&
      typeof Integration.hascompileTemplate == 'function' &&
      !Integration.hascompileTemplate('reviews'))) {
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, buildReview(data));
  }

  // Add badge
  itemHtml = itemHtml.replace(/{{itemBadge}}/g, buildBadge(data));

  // Add Stickers
  itemHtml = itemHtml.replace(/{{itemStickers}}/g, buildStickers(data));

  // Add Sticker Label
  itemHtml = itemHtml.replace(/{{itemAddLabels}}/g, buildAddLabels(data));

  // Add Vendor
  itemHtml = itemHtml.replace(/{{itemVendor}}/g, buildVendor(data));

  // Shop now Btn

  let shopBtnTemplate = `<a href="{{itemUrl}}" class="card-information__shop-now {{shopBtnClassBtn}}">{{shopNowBtn}}</a>`;

  let shopBtnClassBtn = "";
  if (data.available != true) {
    shopBtnClassBtn = "check-stock";
    shopBtnTemplate = shopBtnTemplate.replace(/{{shopNowBtn}}/g, boostPFSThemeConfig.label.check_stock_in_store);
  }else if (shopInStoreProduct == true) {
    shopBtnTemplate = shopBtnTemplate.replace(/{{shopNowBtn}}/g, boostPFSThemeConfig.label.shop_in_store);
  } else if (data.variants.length > 1) {
    shopBtnTemplate = shopBtnTemplate.replace(/{{shopNowBtn}}/g, boostPFSThemeConfig.label.shop_now);
  } else {
    const bulkBuyTag = (data.tags || []).find(tag => tag.toLowerCase().startsWith('multibuy:'));
    const bulkBuyValue = bulkBuyTag ? bulkBuyTag.toLowerCase().split('multibuy:')[1] : null;
    shopBtnTemplate = `
      <add-to-cart
				class='card-information__shop-now'
				data-variant-id='${data.variants[0].id}'
				${bulkBuyValue ? `data-bulk-buy='${bulkBuyValue}'` : ''}
			>
        ${boostPFSThemeConfig.label.add_to_cart}
			</add-to-cart>
      `
  }
  shopBtnTemplate = shopBtnTemplate.replace(/{{shopBtnClassBtn}}/g, shopBtnClassBtn);
  itemHtml = itemHtml.replace(/{{shopNowBtnTemplate}}/g, shopBtnTemplate);

  itemHtml = itemHtml.replace(/{{shopboxBtn}}/g, `
      <form action="javascript:void(0);">
        <button type="submit" class="button secondary sb-findsim-v2" data-sku="${data.url}">
          More Like This
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#a)" fill="currentColor"><path d="M14.448 5.554a7.333 7.333 0 0 0-2.763-4.123.293.293 0 0 0-.349.471 6.751 6.751 0 0 1 2.47 3.521 7.356 7.356 0 0 0-1.138-.088c-4.044 0-7.333 3.29-7.333 7.332 0 .385.03.764.087 1.137a6.782 6.782 0 0 1-3.33-2.224A6.761 6.761 0 0 1 .585 7.332 6.754 6.754 0 0 1 7.332.586c1.073 0 2.099.244 3.05.726a.293.293 0 1 0 .264-.522A7.257 7.257 0 0 0 7.332 0C3.29 0 0 3.289 0 7.332 0 9.01.581 10.65 1.636 11.95a7.364 7.364 0 0 0 3.916 2.497c.227.913.63 1.776 1.197 2.55a.293.293 0 0 0 .473-.347 6.7 6.7 0 0 1-1.028-2.074l.039.006a.293.293 0 1 0 .087-.58 6.828 6.828 0 0 1-.277-.047 6.754 6.754 0 0 1 7.912-7.91c.018.091.035.183.048.274a.293.293 0 0 0 .58-.087l-.006-.036c2.793.826 4.837 3.414 4.837 6.471a6.754 6.754 0 0 1-6.746 6.747 6.71 6.71 0 0 1-4.71-1.916.293.293 0 1 0-.41.42A7.293 7.293 0 0 0 12.669 20C16.71 20 20 16.71 20 12.667c0-3.429-2.367-6.316-5.552-7.113Z"/><path d="M8.577 14.268a.293.293 0 0 0-.33-.25c-.287.038-.582.059-.874.06a.293.293 0 0 0 .002.586h.002c.317-.002.636-.024.949-.066a.293.293 0 0 0 .25-.33ZM9.359 14.368a.294.294 0 0 0 .084-.012c.303-.091.604-.203.892-.333a.293.293 0 1 0-.24-.534c-.266.119-.542.222-.82.306a.293.293 0 0 0 .084.573ZM13.797 9.27a6.698 6.698 0 0 1-.306.822.293.293 0 0 0 .534.24c.13-.29.242-.59.333-.894a.293.293 0 1 0-.561-.168ZM13.392 10.928a.293.293 0 0 0-.405.085 6.8 6.8 0 0 1-.526.702.293.293 0 0 0 .445.38 7.37 7.37 0 0 0 .571-.761.293.293 0 0 0-.085-.406ZM14.27 8.572a.293.293 0 0 0 .329-.25 7.42 7.42 0 0 0 .066-.95.293.293 0 1 0-.586-.003 6.828 6.828 0 0 1-.061.874c-.022.16.09.308.251.33ZM11.177 13.523c.055 0 .11-.015.16-.048.265-.173.521-.365.762-.57a.293.293 0 0 0-.381-.446c-.222.19-.457.367-.701.526a.293.293 0 0 0 .16.538Z"/></g><defs><clipPath id="a"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></svg>
        </button>
      </form>
    `);

  if (data.available == true || priceOnRequestProduct) {
    itemHtml = itemHtml.replace(/{{soldOut}}/g, "");
  } else {
    itemHtml = itemHtml.replace(/{{soldOut}}/g, boostPFSTemplate.soldOutLabelHtml);
  };

  // itemActiveSwapClass
  itemHtml = itemHtml.replace(/{{itemActiveSwapClass}}/g, buildActiveSwapClass(data));

  // Add main attribute (Always put at the end of this function)
  itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
  itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
  itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
  itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
  itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + Utils.buildProductItemUrlWithVariant(data).split('/products/')[1]);
  itemHtml = itemHtml.replace(/{{includeVat}}/g, buildVatExist(data));
  itemHtml = itemHtml.replace(/{{excludeVat}}/g, buildExcludeVatPrice(data));
  itemHtml = itemHtml.replace(/{{itemImageRatio}}/g, boostPFSThemeConfig.custom.aspect_ratio);

  return itemHtml;
};

/************************** END BUILD PRODUCT ITEM **************************/
/************************** BUILD PRODUCT ITEM ELEMENTS **************************/

function buildImages(data) {
	var dataSrcSet = '',
		flipImageSrcSet ='',
		rangeWidths = boostPFSRangeWidths;

	// Build Main Image
	var firstImageHtml = boostPFSTemplate.imageHtml;

	var activeSwapImage = images.length > 1 && boostPFSThemeConfig.custom.show_secondary_image == true;

	for (var i = 0; i < rangeWidths.length; i++) {
		if (images.length > 0) {
			dataSrcSet += Utils.optimizeImage(images[0].src, '480x') ;
		} else {
			dataSrcSet = 'https:'+ boostPFSThemeConfig.custom.fallback_image + rangeWidths[i] + 'x' + ' ' + rangeWidths[i] + 'w';
		}
		if (activeSwapImage) {
			flipImageSrcSet += Utils.optimizeImage(images[1].src, rangeWidths[i] + 'x') + ' ' + rangeWidths[i] + 'w';
		}

		if (i < rangeWidths.length - 1) {
			dataSrcSet += ', ';

			if (activeSwapImage) {
				flipImageSrcSet += ', ';
			}
		}
	}

	var thumbUrl;

	if (images.length > 0) {
		thumbUrl = Utils.optimizeImage(images[0].src, '400x');
	} else {
		thumbUrl = Utils.optimizeImage('https:'+ boostPFSThemeConfig.custom.fallback_image, '400x');
	}

	firstImageHtml = firstImageHtml.replace(/{{imageUrl}}/g, thumbUrl);
	firstImageHtml = firstImageHtml.replace(/{{dataSrcSet}}/g, dataSrcSet);

	// Build Image Swap
	var secondImageHtml = '';
	if (boostPFSConfig.custom.show_secondary_image && images.length > 1) {
		var flipImageUrl = Utils.optimizeImage(images[1].src, '500x');
		secondImageHtml = boostPFSTemplate.imageHtml;
		secondImageHtml = secondImageHtml.replace(/{{imageUrl}}/g, flipImageUrl);
		secondImageHtml = secondImageHtml.replace(/{{dataSrcSet}}/g, flipImageSrcSet);

	}

	return firstImageHtml + secondImageHtml;
}

function buildBadge(data) {
    var html = '';
    let published_days_before = Math.floor((Date.now() - new Date(data.published_at)) / 1000 / 86400 );
    if (!showSticker) {
      if (onSale) {
        html += boostPFSTemplate.saleLabelHtml;
      } else if (published_days_before < 30) {
          html += boostPFSTemplate.newLabelHtml;
      }
    }
    return html;
}

function buildStickers(data) {
  var html = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('show_stickers') &&
    boostPFSThemeConfig.custom.show_stickers == true) {
	  html += '<div class="card-information__stickers">';
	  for (tag of data.tags) {
		  if (tag.startsWith('sticker')) {
			  var stickerProperties = tag.split(':');
			  let background = stickerProperties[3];
			  let color = stickerProperties[2];
			  html += '<div class="card-information__sticker card-information__sticker--' + stickerProperties[4].toLowerCase() + '"' +
				  ' style="background-color:' + background + '; color:' + color + ';">' +
				  stickerProperties[1] +
				  '</div>';
		  }

		  if (tag.indexOf('epos:click-collect-exclusive:true') !== -1) {
			  html += '<div class="card-information__sticker card-information__sticker--rectangle" style=" color:#000000; background-color:rgba(83, 150, 53, 0.5);"> Click & Collect Exclusive</div>';
		  }
	  }
	  html += '</div>';
  }
  return html;
}

function buildAddLabels(data) {
  let addLabelHtmls = "";
  let sticker_tags = data.tags.filter(tag => tag.toLowerCase().includes('sticker'));
  let multibuy_tags = data.tags.filter(tag => tag.toLowerCase().includes('multibuy'));
  let discount_tags = data.tags.filter(tag => tag.toLowerCase().includes('discount-'));
  let allowed_shapes = ['rectangle', 'circular'];
  if ( sticker_tags.length > 0 ) {
    let stickersHtml = '';
    sticker_tags.forEach( sticker => {
      let escaped_sticker = htmlencode(sticker);
      let sticker_variables = escaped_sticker.split(":");

      if (sticker_variables.length < 2) return false;
      let sticker_colour = '';
      let sticker_priority = 0;
      let sticker_shape = "rectangle";
      let sticker_text = sticker_variables.pop();

      sticker_variables.forEach((item, index) => {
        if (index === 0) {
          return;
        } else if (isInt(item)) {
          sticker_priority = item;
        } else if (allowed_shapes.includes(item)) {
          sticker_shape = item;
        } else {
          sticker_colour = item;
        }
      });

      let stickerHTML = boostPFSTemplate.stickerHtml.replace(/{{stickerColor}}/g, sticker_colour );
      stickerHTML = stickerHTML.replace(/{{stickerText}}/g, sticker_text );
      stickerHTML = stickerHTML.replace(/{{stickerShape}}/g, sticker_shape );
      if (sticker_priority != 0) {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, 'order: -' + sticker_priority + ';' );
      } else {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, '' );
      }

      stickersHtml += stickerHTML;
    })
    addLabelHtmls += boostPFSTemplate.addLabelsHtml.replace(/{{addLabels}}/g, stickersHtml );
  }

  if ( discount_tags.length > 0 ) {
    let stickersHtml = '';
    discount_tags.forEach( sticker => {
      let escaped_sticker = htmlencode(sticker);
      let sticker_content = escaped_sticker.toLowerCase().replace('discount-', "");

      let sticker_colour = 'green';
      let sticker_priority = 0;
      let sticker_shape = "rectangle";
      let sticker_text = "";
      if (sticker_content.includes('%')) {
        sticker_text = sticker_content + " Off";
      }else {
        sticker_text = "€" + sticker_content + " Off";
      }

      let stickerHTML = boostPFSTemplate.stickerHtml.replace(/{{stickerColor}}/g, sticker_colour );
      stickerHTML = stickerHTML.replace(/{{stickerText}}/g, sticker_text );
      stickerHTML = stickerHTML.replace(/{{stickerShape}}/g, sticker_shape );
      if (sticker_priority != 0) {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, 'order: -' + sticker_priority + ';' );
      } else {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, '' );
      }

      stickersHtml += stickerHTML;
    })
    addLabelHtmls += boostPFSTemplate.addLabelsHtml.replace(/{{addLabels}}/g, stickersHtml );
  }

  if ( multibuy_tags.length > 0 ) {
    let stickersHtml = '';
    multibuy_tags.forEach( sticker => {
      let escaped_sticker = htmlencode(sticker);
      escaped_sticker = escaped_sticker.toLowerCase().replace('multibuy:', "")
      let sticker_variables = escaped_sticker.split("-");

      let sticker_colour = 'green';
      let sticker_priority = 0;
      let sticker_shape = "rectangle";
      let sticker_text = "Buy " + sticker_variables[0] + " for €" + sticker_variables[1];

      let stickerHTML = boostPFSTemplate.stickerHtml.replace(/{{stickerColor}}/g, sticker_colour );
      stickerHTML = stickerHTML.replace(/{{stickerText}}/g, sticker_text );
      stickerHTML = stickerHTML.replace(/{{stickerShape}}/g, sticker_shape );
      if (sticker_priority != 0) {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, 'order: -' + sticker_priority + ';' );
      } else {
        stickerHTML = stickerHTML.replace(/{{stickerPriority}}/g, '' );
      }

      stickersHtml += stickerHTML;
    })
    addLabelHtmls += boostPFSTemplate.addLabelsHtml.replace(/{{addLabels}}/g, stickersHtml );
  }

  return addLabelHtmls;
}

function htmlencode(r) {
  return r.replace(/[\x26\x0A\<>'"]/g, function (r) {
    return '&#' + r.charCodeAt(0) + ';';
  });
}

function isInt(value) {
  return !isNaN(value) &&
         parseInt(Number(value)) == value &&
         !isNaN(parseInt(value, 10));
}

function buildVendor(data) {
  var html = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
    boostPFSThemeConfig.custom.show_vendor == true) {
    html = '<div class="card-information__vendor">' + boostPFSTemplate.vendorHtml + '</div>';
  }
  return html;
}

function buildPrice(data) {
  var html = '';

  if (
    data.tags.indexOf('epos:call-for-price:true') !== -1 ||
    data.tags.indexOf('epos:call-for-price:1') !== -1
  ) {
    return html;
  }

  const discountTags = data.tags.filter((tag) => {
    const tagLow = tag.toLowerCase();
    return tagLow.startsWith('discount-') || (tagLow.startsWith('sticker:') && tagLow.includes('% off'))
  });

  let compareAtPrice = data.compare_at_price_min;
  let price = data.price_min;
  let stickerPrice = price;

  discountTags.forEach((tag) => {
    const tagLow = tag.toLowerCase();
    let discountedPrice = stickerPrice;
    if (tagLow.startsWith('discount-')) {
      const discountValue = Number(tagLow.replace('discount-',''));
      if (isNaN(discountValue)) return;
      discountedPrice = price - discountValue;
    } else {
      const discountPercent = Number(tagLow.split('% off')[0].split(':').reverse()[0]);
      if (isNaN(discountPercent) || discountPercent <= 0 || discountPercent > 100) return;
      discountedPrice = Math.ceil(price * (100 - discountPercent)) / 100;
    }
    
    if (discountedPrice < stickerPrice) {
      stickerPrice = discountedPrice;
    }
  });

  if (stickerPrice < price) {
    compareAtPrice = price;
    price = stickerPrice;
  }

  if (price < compareAtPrice) {
    html += '<div class="price price--on-sale">';
    html += '<span>' + Utils.formatMoney(price) + '</span>';
    html += '<s>' + Utils.formatMoney(compareAtPrice) + '</s>';
    html += '</div>';
  } else {
    html +=
      (priceVaries ? boostPFSThemeConfig.label_basic.from + ' ' : '') +
      boostPFSThemeConfig.label_basic.only + ' ';
    html += '<div class="price price--regular-price">' +
      Utils.formatMoney(price) +
      '</div>';
  }

  return html;
}

function buildVatExist(data) {
	var html = '';
	var priceForCall = false;

	if (data.tags.indexOf('epos:call-for-price:true') !== -1 || data.tags.indexOf('epos:call-for-price:1') !== -1) {
		priceForCall = true;
	}

	if (vatExists === true && priceForCall === false) {
		html += '<span class="card-information__price-include-vat"> ';
		if (vatExempt === true) {
			html +=	'VAT Exempt';
		} else {
			html +=	'Inc VAT';
		}
		html+=	'</span>';
	}

	return html;
}
function buildExcludeVatPrice(data) {
	var html = '';
	var exPrice;

	if (vatExempt === false) {
		var priceForCall = false;
		if (data.tags.indexOf('epos:call-for-price:true') !== -1 || data.tags.indexOf('epos:call-for-price:1') !== -1) {
			priceForCall = true;
		}
		if (vatExists === true && priceForCall === false) {
			var priceForCall = false;
			if (data.tags.indexOf('epos:call-for-price:true') !== -1 || data.tags.indexOf('epos:call-for-price:1') !== -1) {
				priceForCall = true;
			}

			if (discountTag === true) {
				exPrice = (data.price_min - data.price_min * discountValue) / vatRate
			} else {
				exPrice = data.price_min / vatRate
			}

			html += '<div className="card-information__price-exclude-vat'+ vatRate +'">' + Utils.formatMoney(exPrice) + ' ex VAT</div>';
		}
	}
	return html;
}

function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}

function buildReview(data) {
  var html = '';
  if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
    boostPFSThemeConfig.custom.show_product_review == true) {
    html = '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
  }
  return html;
}

function buildActiveSwapClass(data) {
  if (!Utils.isMobile() && images.length > 1 &&
    boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
    boostPFSThemeConfig.custom.active_image_swap == true) {
    return 'has-bc-swap-image';
  }
  return '';
}



/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
/************************** BUILD TOOLBAR **************************/
  // Build Pagination
  ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
    // Get page info
    if (!totalProduct) totalProduct = this.totalProduct;
    var currentPage = parseInt(Globals.queryParams.page);
    var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

    if (totalPage > 1) {
      var paginationHtml = boostPFSTemplate.paginateHtml;

      // Build Previous
      var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
      previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
      paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

      // Build Next
      var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
      nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
      paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

      // Build page items

      // Create page items array
      var beforeCurrentPageArr = [];
      for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
        beforeCurrentPageArr.unshift(iBefore);
      }
      if (currentPage - 4 > 0) {
        beforeCurrentPageArr.unshift('...');
      }
      if (currentPage - 4 >= 0) {
        beforeCurrentPageArr.unshift(1);
      }
      beforeCurrentPageArr.push(currentPage);

      var afterCurrentPageArr = [];
      for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
        afterCurrentPageArr.push(iAfter);
      }
      if (currentPage + 3 < totalPage) {
        afterCurrentPageArr.push('...');
      }
      if (currentPage + 3 <= totalPage) {
        afterCurrentPageArr.push(totalPage);
      }

      // Build page items
      var pageItemsHtml = '';
      var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
      for (var iPage = 0; iPage < pageArr.length; iPage++) {
        if (pageArr[iPage] == '...') {
          pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
        } else {
          pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
        }
        pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
        pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
      }
      paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
      return paginationHtml;
    }

    return '';
  };

// Build Sorting
ProductSorting.prototype.compileTemplate = function() {
  var html = boostPFSTemplate.sortingHtml;
  if (boostPFSThemeConfig.custom.show_sort_by && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
    var sortingArr = Utils.getSortingList();
    if (sortingArr) {
      var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
      // Build content
      var sortingItemsHtml = '';
      for (var k in sortingArr) {
        activeClass = '';
        if (paramSort == k) {
          activeClass = 'boost-pfs-filter-sort-item-active';
        }
        sortingItemsHtml += '<li aria-label="' + sortingArr[k] + '"><a href="#" data-sort="' + k + '" class="' + activeClass + '"  title="' + sortingArr[k] + '" aria-label="' + sortingArr[k] + '">' + sortingArr[k] + '</a></li>';
      }
      html = html.replace(/{{sortingItems}}/g, sortingItemsHtml);
      html = html.replace(/{{sortingLabel}}/g, Labels.sorting);
    }
  }
  return html;
};

ProductSorting.prototype.render = function() {
  jQ(Selector.topSorting).html(this.compileTemplate());

  if (jQ('.boost-pfs-filter-top-sorting').hasClass('boost-pfs-filter-sort-active')) {
    jQ('.boost-pfs-filter-top-sorting').toggleClass('boost-pfs-filter-sort-active');
  }

  var labelSort = '';
  var paramSort = Utils.stripHtml(Globals.queryParams.sort) || '';
  var sortingList = Utils.getSortingList();
  if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
    labelSort = sortingList[paramSort];
  } else {
    labelSort = Labels.sorting_heading;
  }

  jQ('.boost-pfs-filter-top-sorting button span span').text(labelSort);
}

// Build Sorting event
ProductSorting.prototype.bindEvents = function() {
		var _this = this;
		jQ('.boost-pfs-filter-filter-dropdown').hide();

		jQ('.boost-pfs-filter-filter-dropdown a').click(function(e) {
			e.preventDefault();
			FilterApi.setParam('sort', jQ(this).data('sort'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(".boost-pfs-filter-top-sorting > button").click(function() {
			if (jQ(this).parent().hasClass('boost-pfs-filter-sort-active')) {
				jQ(this).parent().removeClass('boost-pfs-filter-sort-active');
				jQ('.boost-pfs-filter-filter-dropdown').hide();
			} else {
				jQ(this).parent().addClass('boost-pfs-filter-sort-active');
				jQ('.boost-pfs-filter-filter-dropdown').show();
			}
		});

		jQ(Selector.filterTreeMobileButton).click(function() {
			jQ('.boost-pfs-filter-top-sorting-mobile .boost-pfs-filter-filter-dropdown').hide();
		});

		jQ(document).on('click', function (e) {
			if (jQ(e.target).parents('.boost-pfs-filter-top-sorting').find(".boost-pfs-filter-filter-dropdown").length === 0) {
				jQ('.boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
			}
		});
	};
// For Toolbar - Build Display type
ProductDisplayType.prototype.compileTemplate = function() {

  var itemHtml = '<span>' + boostPFSThemeConfig.label.toolbar_viewas + '</span>';
  if (boostPFSThemeConfig.custom.product_item_type == 'grid') {
    if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
    } else {
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
        itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
    }
  } else {
    if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 2) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-2" data-view="grid-2"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 3) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-3" data-view="grid-3"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 4) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-4" data-view="grid-4"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 5) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-5" data-view="grid-5"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid', 6) + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid {{class.productDisplayType}}-grid-6" data-view="grid-6"><span class="icon-fallback-text"></span></a>';
    } else {
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="' + buildDisplayTitle('list') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"></span></a>';
      itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="' + buildDisplayTitle('grid') + '" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"></span></a>';
    }
  }

  itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

  return itemHtml;
};

function buildDisplayTitle(type, count) {
  if(type === '') return type;
  // Build title for list view
  if(type === 'list') {
    return Labels.listView || 'List view';
  }
  // Build title for grid view
  if(typeof count === 'undefined' || count === 0) return Labels.gridView || 'Grid view';
  return (Labels.gridViewColumns || 'Grid view {{ count }} Columns').replace(/{{ count }}/g, count);
}

var originalRenderProductDisplayType = ProductDisplayType.prototype.render;
ProductDisplayType.prototype.render = function() {
  // Call the original function in our app lib.
  // We don't have to copy a very big function out here to modify.
  // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
  originalRenderProductDisplayType.call(this);

  // Do your custom code after the original function has run
  // Active current display type
  if (this.$element.length) {
    this.$element.find(this.selector.productDisplayTypeList).removeClass('active');
    this.$element.find(this.selector.productDisplayTypeGrid).removeClass('active');
    if (Utils.stripHtml(Globals.queryParams.display) == 'list') {
      this.$element.find(this.selector.productDisplayTypeList).addClass('active');
    } else if (Utils.stripHtml(Globals.queryParams.display) == 'grid') {
      if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
        var curentGridColumn = boostPFSThemeConfig.custom.products_per_row;
        this.$element.find(this.selector.productDisplayTypeGrid).each(function(){
          var $parent = jQ(this).parent();
          var $cssNames = jQ('.boost-pfs-filter-top-display-type').attr('class').split(' ');
          var $activeClass = $cssNames[$cssNames.length - 1];
          var indexCurrentColumn = $activeClass.split('-')[$activeClass.split('-').length - 1];

          if($parent.hasClass('boost-pfs-filter-view-as-click') && jQ(this).data('view') == $activeClass){
              jQ(this).addClass('active');

              // jQ('.boost-pfs-filter-product-item').removeClass(function(index, css) {
              // return (css.match (/(^|\s)boost-pfs-filter-grid-width-\S+/g) || []).join(' ');
              // }).addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
              if(jQ('.boost-pfs-filter-product-item').length > 0) {
                var arrClass = jQ('.boost-pfs-filter-product-item').attr('class').split(' ');
                var prevClass = '';
                for (var i = 0; i < arrClass.length; i++) {
                  if(arrClass[i].match (/(^|\s)boost-pfs-filter-grid-width-\S+/g)) {
                    prevClass = arrClass[i];
                    break;
                  }
                }
                jQ('.boost-pfs-filter-product-item').removeClass(prevClass);
                jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);

                // jQ('.boost-pfs-filter-product-item').className = jQ('.boost-pfs-filter-product-item').className.replace(/(^|\s)boost-pfs-filter-grid-width-\S+/g , '');
                // jQ('.boost-pfs-filter-product-item').addClass('boost-pfs-filter-grid-width-' + indexCurrentColumn);
              }

          } else if(
              (!$parent.hasClass('boost-pfs-filter-view-as-click') || Globals.queryParams.event_type == 'history')
              && jQ(this).data('view').split('-')[1] == curentGridColumn
            ) {
              jQ(this).addClass('active');
          }
        });

      } else {
        this.$element.find(this.selector.productDisplayTypeGrid).addClass('active');
      }
    }
  }
};

// Build Show Limit
ProductLimit.prototype.compileTemplate = function() {
	var html = '';
  if (boostPFSTemplate.hasOwnProperty('showLimitHtml')) {
    var numberList = Settings.getSettingValue('general.showLimitList');
    if (numberList != '') {
      // Build content
      var showLimitItemsHtml = '';
      var arr = numberList.split(',');
      for (var k in arr) {
        showLimitItemsHtml += '<option value="' + arr[k] + '">' + arr[k] + '</option>';
      }
      html = boostPFSTemplate.showLimitHtml.replace(/{{showLimitItems}}/g, showLimitItemsHtml);
    }
  }
  return html;
};
// Build Breadcrumb
Breadcrumb.prototype.compileTemplate = function(colData) {
  if (!colData) colData = this.collectionData;
  var breadcrumbItemsHtml = '';
  if (boostPFSTemplate.hasOwnProperty('breadcrumbHtml')) {
    if (typeof colData !== 'undefined' && colData.hasOwnProperty('collection')) {
      var colInfo = colData.collection;
      if (typeof this.collectionTags !== 'undefined' && this.collectionTags !== null) {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemLink.replace(/{{itemLink}}/g, '/collections/' + colInfo.handle).replace(/{{itemTitle}}/g, colInfo.title);
        breadcrumbItemsHtml += " {{breadcrumbDivider}} ";
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, this.collectionTags[0]);
      } else {
        breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, colInfo.title);
      }
    } else {
      breadcrumbItemsHtml += boostPFSTemplate.breadcrumbItemSelected.replace(/{{itemTitle}}/g, Settings.getSettingValue('label.defaultCollectionHeader'));
    }
  }
  return breadcrumbItemsHtml
};

/************************** END BUILD TOOLBAR **************************/

// Add additional feature for product list, used commonly in customizing product list
ProductList.prototype.afterRender = function(data) {
  if (!data) data = this.data;

  // Intergrate Review Shopify
  if (window.SPR &&
    typeof window.SPR.initDomEls == 'function' &&
    typeof window.SPR.loadBadges == 'function' &&
    boostPFSThemeConfig.custom.show_product_review) {
    window.SPR.initDomEls();
    window.SPR.loadBadges();
  }
};

// Build additional elements
Filter.prototype.afterRender = function(data) {
  if (!data) data = this.data;
	var currentPage = parseInt(Globals.queryParams.page);
	var productFrom;
	var productTo;

	if (currentPage === 1) {
		productFrom = 1;
		if (data.total_product <= Globals.queryParams.limit) {
			productTo = data.total_product;
		} else {
			productTo = Globals.queryParams.limit;
		}
	} else {
		productFrom = Globals.queryParams.limit * (currentPage - 1) + 1;
		productTo = Globals.queryParams.limit * currentPage;
	}

	var productCountText;
	if (data.total_product === 1) {
		productCountText = ' item';
	} else if (data.total_product > 1) {
		productCountText = ' items';
	}
	if (data.total_product > 0) {
		jQ('.boost-pfs-filter-total-product').html('Showing ' + productFrom + '-' + productTo + ' of ' + data.total_product + productCountText);
	} else {
		jQ('.boost-pfs-filter-total-product').addClass('hidden');
	}

  // Prevent double tap on iOS
  var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
  if (isiOS) {
    Utils.isMobile() && jQ(".boost-pfs-filter-product-item").find("a").on("touchstart", function() {
      isScrolling = !1
    }).on("touchmove", function() {
      isScrolling = !0
    }).on("touchend", function() {
      isScrolling || (window.location = jQ(this).attr("href"))
    });
  }

  // Build Image Swap. Put this function here to impprove the pagespeed.
  swapImage(data);

  if (typeof boostRemoveImageLoadingAnimation == 'function') {
    boostRemoveImageLoadingAnimation(jQ(Selector.products).find('[data-boost-image-loading-animation]'));
  }

	// Layout Fullwidth Page
  if (boostPFSThemeConfig.custom.hasOwnProperty('layout_type') && boostPFSThemeConfig.custom.layout_type == 'fullwidth' && !Utils.isMobile()) {
    jQ('body').addClass('boost-pfs-filter-fullwidth-page');
  }
  document.addEventListener('scroll', function() {
    if(jQ('.boost-pfs-filter-tree-h.boost-pfs-filter-stick').length > 0 && jQ(window).width() > 767){
      jQ('.boost-pfs-filter-top-sorting .boost-pfs-filter-filter-dropdown').hide().parent().removeClass('boost-pfs-filter-sort-active');
    }
  });

  // Fix confict Sticky Mobile theme Streamline
  if(jQ('.site-nav__thumb-menu').length > 0 && Utils.isMobile()){
    var heightHeaderThemeStick = jQ('.site-nav__thumb-menu').height() + 40;
    jQ('.boost-pfs-filter-tree-mobile-button-stick-wrapper').css('bottom',heightHeaderThemeStick).addClass('boost-pfs-filter-sticky-bottom');
    jQ('.boost-pfs-filter-mobile-style1').addClass('boost-pfs-filter-mobile-style1-sticky-bottom');
  }
};

var original_onClickEventProductDisplayType = ProductDisplayType.prototype._onClickEvent;
ProductDisplayType.prototype._onClickEvent = function(event) {
  // Call the original function in our app lib.
  // We don't have to copy a very big function out here to modify.
  // function.call(this, param1, param2) binds the "this" pointer and params to the original function.
  original_onClickEventProductDisplayType.call(this, event);

  // Do your custom code after the original function has run
  /*  View As Type 2/3/4/5/6 */

  if (boostPFSThemeConfig.custom.view_as_type == 'view_as_type_list_grid_multi_col' && !Utils.isMobile()) {
      jQ('.boost-pfs-filter-top-display-type').addClass('boost-pfs-filter-view-as-click');
      var currentClass = jQ(event.target).data('view');
      jQ('.boost-pfs-filter-top-display-type')[0].className = jQ('.boost-pfs-filter-top-display-type')[0].className.replace(/(^|\s)grid-\S+/g , '');
      jQ('.boost-pfs-filter-top-display-type').addClass(currentClass);
  }
}

// Swap Image
function swapImage(data) {
  if (!Utils.isMobile()) {
    if (boostPFSThemeConfig.custom.hasOwnProperty('active_image_swap') &&
      boostPFSThemeConfig.custom.active_image_swap == true) {
      var dataSrcSetFlipImg = '',
        dataSrcFlipImg = '',
        flipImageAlt = '',
        dataSizes = 'auto',
        dataWidths = '',
        html = '';

      jQ(".boost-pfs-filter-product-item").each(function() {
        var productItemSelector = jQ(this);
        var imgSelector = productItemSelector.find('.boost-pfs-filter-product-item-main-image');

        if (typeof imgSelector.data('img-flip-src') != 'undefined' &&
          imgSelector.data('img-flip-src') != '') {
          dataSrcFlipImg = imgSelector.data('img-flip-src');
          dataSrcSetFlipImg = imgSelector.data('img-flip-srcset');
          flipImageAlt = imgSelector.attr('alt');
          dataWidths = imgSelector.data('widths');
          html = '<img class="boost-pfs-filter-product-item-flip-image lazyload Image--lazyLoad"' +
            'data-srcset="' + dataSrcSetFlipImg + '" ' +
            'data-src="' + dataSrcFlipImg + '" ' +
            'data-widths="[' + dataWidths + ']" ' +
            'data-sizes="' + dataSizes + '" ' +
            'src="' + boostPFSImgDefaultSrc + '" ' +
            'alt="' + flipImageAlt + '" />';

          productItemSelector.find('.boost-pfs-filter-product-item-image-link').append(html);
        }

      });
    }
  }
}

// Build Placeholder for the first load
function boostRemoveImageLoadingAnimation($selector) {
  if ($selector.length) {
    $selector.removeAttr('data-boost-image-loading-animation');
  }
}
/* Expand Filter */
jQ(document).ready(function() {
    // Fix issue header fix on the Parallax theme
    if(jQ('.mm-fixed-top').length > 0){
      var headerFixedHeight = jQ('.mm-fixed-top').height();
      jQ('.boost-pfs-filter-collection-header-wrapper').css('margin-top', headerFixedHeight);
    }
});

	FilterOptionItem.prototype.beforeRender = function () {
		this.countLabel = this.docCount;
	}
})();
